import React from "react";
import { createRoot } from "react-dom/client";
import { HashRouter } from "react-router-dom";
import App from "./App";
import { MenuProvider } from "./contexts/MenuContext";
const container = document.getElementById("access-control-admin-root");

if (container) {
	createRoot(container).render(
		<HashRouter>
			<MenuProvider>
				<App />
			</MenuProvider>
		</HashRouter>,
	);
}
